import HeaderLayout from './HeaderLayout';
import HeaderLayoutMs from './HeaderLayoutMs';
import HeaderLayoutMuse from './HeaderLayoutMuse';
import HeaderLayoutMuseAndroidPromo from './HeaderLayoutMuseAndroidPromo';
import HeaderLayoutSubscriptionActivate from './HeaderLayoutSubscriptionActivate';
import HeaderLayoutCheckoutSuccess from './HeaderLayoutCheckoutSuccess';

export default HeaderLayout;
export {
  HeaderLayoutMs,
  HeaderLayoutCheckoutSuccess,
  HeaderLayoutMuse,
  HeaderLayoutMuseAndroidPromo,
  HeaderLayoutSubscriptionActivate
};



// WEBPACK FOOTER //
// ./src/views/Layout/HeaderLayout/index.js